
export const displayPayPalPayLaterOffer = (isPayPalPayLaterEnabled,payPalPayLaterMin,payPalPayLaterMax,cartTotal) => {
    return isPayPalPayLaterEnabled && cartTotal>=payPalPayLaterMin && cartTotal<=payPalPayLaterMax;
};
